import { request } from './request';

export const getDocumentById = (id) => request(`documents/${id}`);

export const generateDocuments = (id, entity) =>
  request(`documents/generate?id=${id}&entity=${entity}`);

export const getSignedUrl = (id) => request(`documents/${id}/signed-url`);

export const updateDocument = (id, body) => {
  return request(
    `documents/${id}`,
    { method: 'PATCH', body },
    'Document updated successfully!',
  );
};

export const createDocument = (body) =>
  request(
    `documents`,
    {
      method: 'POST',
      body,
    },
    body.withSignature ? 'DAP signed successfully!' : null,
  );

export const deleteDocument = (id) => {
  request(
    `documents/${id}`,
    { method: 'DELETE' },
    'Document deleted successfully!',
  );
};
